<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		/>

		<section class="main-content background-light packages-section">
			<div class="row promotions-row align-left flex-row">
				<div v-for="item in packagesData" :key="item.ID" class="columns column3 promo-wrap">
					<nuxt-link :to="localePath(`/${item.filename}`)">
						<picture>
							<source v-if="item.overviewImageWebp" :srcset="item.overviewImageWebp" type="image/webp" />
							<source :srcset="item.overviewImage" />
							<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
						</picture>
					</nuxt-link>
					<div class="content">
						<h3>{{ item.header }}</h3>
						<div v-parse-links v-html="item.overviewContent" />
						<nuxt-link :to="localePath(`/${item.filename}`)" class="promo-button">
							{{ $t('viewThisPackage') }}
							<font-awesome-icon icon="fa-light fa-arrow-right" size="1x" />
						</nuxt-link>
					</div>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();

const { data: packagesData } = await useWebsiteFetch('packages', {
	query: { language: locale.value },
	key: `${locale.value}/packages`,
});
</script>

<style lang="scss" scoped>
.packages-section .block-item {
	width: 32%;
}

.promotions-row {
	justify-content: normal;

	.promo-wrap {
		float: none;
		display: flex;
		flex-flow: column nowrap;
	}

	h3 {
		text-transform: uppercase;
	}

	.content {
		display: flex;
		flex-flow: column nowrap;
		height: 100%;
		margin: 20px 0;
	}

	.promo-button {
		margin-top: auto;
		width: 100%;
		border-bottom: 1px solid #000;
		color: #000;
		text-transform: uppercase;
		font-family: var(--heading-font-family);
		font-size: 12px;
		line-height: 16px;
		padding: 8px 0;
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;

		svg {
			font-size: 16px;
			transform: rotate(315deg);
		}
	}
}

@media (max-width: 920px) {
	.packages-section .block-item {
		width: 48%;
	}
}

@media (max-width: 680px) {
	.packages-section .block-item {
		width: 100%;
	}
}
</style>
